'use client';

import React from 'react';
import { useVersionTree } from '@/components/versions/useVersionTree';
import { SystemUserAvatar } from '@/components/SystemUserAvatar';

/** One-line version summary, "v5 (avatar) – description", from the version picker's loaded rows. */
export function AgentVersionCell({ versionId, fallbackLabel }: { versionId: number; fallbackLabel?: string }) {
	const row = useVersionTree((s) => s.rows.find((r) => r.id === versionId));
	if (!row) return <span className="font-medium">{fallbackLabel ?? `#${versionId}`}</span>;

	const note = row.status === 'draft' ? 'Work in progress' : row.description || row.name;
	return (
		<span className="inline-flex min-w-0 max-w-full items-center gap-1" title={note ?? row.label}>
			<span className="shrink-0 font-medium">{row.label}</span>
			{row.author && <SystemUserAvatar systemUserId={row.author} size="xs" />}
			{note && <span className="truncate text-muted-foreground">– {note}</span>}
		</span>
	);
}
